module.exports = __webpack_public_path__ + "img/m4x14_gb818.prt.12805f09.jpg";